<div class="flex flex-column">
  <div class="col-12">
    <p>Usa le linguette ACL/Tokens per accedere alla sezione desiderata...</p>
    <p-button (click)="throwException()">Throw test exception (admin only)</p-button>
    <br>
    <br>
    <p-tabView>
      <p-tabPanel header="ACL">
        <p-card>
          <ng-template pTemplate="header">
            <i class="pi pi-folder"></i> Gruppi ACL
          </ng-template>
          <ng-template pTemplate="body">

            <p-button (click)="add()">
              <i class="pi pi-plus"></i>
              Crea Gruppo
            </p-button>
            <br>
            <br>
            <p-table [loading]="loading" [value]="groups" [lazy]="true"
                     [rows]="100" [rowHover]="true"
                     styleClass="p-datatable-striped p-datatable-sm"
                     (onLazyLoad)="filter($event)" [sortField]="filterStringifier.name | pascalCase">
              <ng-template pTemplate="header">
                <tr>
                  <th [pSortableColumn]="filterStringifier.name | pascalCase">Nome gruppo
                    <p-sortIcon [field]="filterStringifier.name | pascalCase"></p-sortIcon>
                  </th>
                  <th [pSortableColumn]="filterStringifier.description | pascalCase">Descrizione
                    <p-sortIcon [field]="filterStringifier.description | pascalCase"></p-sortIcon>
                  </th>
                  <th>Utenti</th>
                  <th>Permessi</th>
                  <th>Azioni</th>
                </tr>
                <tr>
                  <th>
                    <app-table-string-filter
                      [field]="filterStringifier.name!.toString()"></app-table-string-filter>
                  </th>
                  <th>
                    <app-table-string-filter
                      [field]="filterStringifier.description!.toString()"></app-table-string-filter>
                  </th>
                  <th></th>
                  <th>
                    <app-table-string-filter
                      [field]="filterStringifier.permissionName!.toString()"
                      [customMatchModeOptions]="[{label:'Descrizione permesso', value: 'contains'}]"
                    ></app-table-string-filter>
                  </th>
                  <th>-</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item let-index="rowIndex">
                <tr>
                  <td>
                    {{ obj(item).name }}
                  </td>
                  <td>
                    {{ obj(item).description }}
                  </td>
                  <td>
                    <div *ngFor="let user of obj(item).users; let isLast=last">
                      {{ users[user.userId].username }}
                      <span *ngIf="!isLast">, </span>
                    </div>
                  </td>
                  <td>
                    <div *ngFor="let perm of obj(item).permissions; let isLast=last">
                      <strong>{{ getPermissionCategory(perm.permission) }}</strong>: {{ getPermissionDescription(perm.permission) }}
                    </div>
                  </td>
                  <td>
                    <button pButton type="button" (click)="edit(item)"
                            class="p-button-raised p-button-sm p-button-secondary"
                            pTooltip="Modifica {{obj(item).name}}" tooltipPosition="top">
                      <span class="pi pi-cog"></span>
                    </button>
                    <button pButton type="button" (click)="delete(item)"
                            class="p-button-raised p-button-sm p-button-danger p-button-outlined"
                            pTooltip="Elimina {{obj(item).name}}" tooltipPosition="top">
                      <span class="pi pi-trash"></span>
                    </button>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </ng-template>
          <ng-template pTemplate="footer">

          </ng-template>
        </p-card>
      </p-tabPanel>
      <p-tabPanel header="Tokens">
        <p-card>
          <ng-template pTemplate="header">Tuo token</ng-template>
          <ng-template pTemplate="body">
            <div style="width: 100%; text-wrap: auto; word-break: break-all">{{ token }}</div>
          </ng-template>
        </p-card>
      </p-tabPanel>
    </p-tabView>


  </div>
</div>
